export default "__VITE_ASSET__SqwjkcZh__"